/**
 * Whether a bonus program uses the sub-period pattern — one sign-off period that
 * spans several calculation windows (e.g. weekly calculation on a 4-weekly
 * sign-off cycle). Data-driven off the program's `signOffCadenceLength`; absent
 * or 1 means the ordinary single-window program, so this returns false and every
 * sub-period code path stays inert.
 */
const programHasSubPeriods = (
  program: BonusTypes.BonusProgram | undefined,
): boolean => (program?.signOffCadenceLength ?? 1) > 1;

export default programHasSubPeriods;
